import { useQuery } from '@tanstack/vue-query'
import { listingRequestKeys } from './listingRequestQueryKeys'
import { getListingRequestStatusCounts } from './listingRequestEndpoints'
import { parseListingRequestStatusCounts } from './listingRequestParser'

// Counts behind the Sell Request table's KPI filter cards: true per-status
// totals for the seller, independent of the filter and the page on screen.
export function useListingRequestStatusCountsQuery() {
  return useQuery({
    queryKey: listingRequestKeys.statusCounts(),
    queryFn: () => getListingRequestStatusCounts().then(parseListingRequestStatusCounts),
  })
}
